import script from "./DialogSupply.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogSupply.vue?vue&type=script&setup=true&lang=ts"

import "./DialogSupply.vue?vue&type=style&index=0&id=27955b80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27955b80"]])

export default __exports__